<!-- 调整订单金额 -->
<template>
  <div class="container">
    <el-dialog append-to-body :visible.sync="dialogVisible" width="85%">
      <header class="header">
        <svg-icon @click="dialogVisible = false" style="color: #000; height: 0.25rem" iconClass="close"></svg-icon>
      </header>
      <div style="padding: 0 0.24rem">
        <main class="main">
          <el-table :header-cell-style="{
            backgroundColor: '#FDEFE7', color: '#000000'
          }" border :data="tableData" style="width: 100%">
            <el-table-column align="center" prop="date" label="子订单号" width="180">
              <template slot-scope="scope">
                <div class="tableLine1">
                  <div class="btns1">{{ scope.row.stateName }}</div>
                  <p class="p1">子订单号</p>
                </div>
                <p class="p2">{{ scope.row.orderChildrenId }}</p>
                <p class="p3">{{ scope.row.resourceName ? scope.row.resourceName : scope.row.resourceNameEn }}</p>
                <p class="p5">{{ scope.row.stockCompanyName }}</p>
              </template>
            </el-table-column>
            <el-table-column width="400" align="center" prop="name" label="商品">
              <template slot-scope="scope">
                <div class="tableLine2" v-for="(item, index) in scope.row.orderListDetailResultList" :key="index">
                  <div class="left">
                    <div style="margin-right: 0.2rem;">
                      <div class="p1">
                        <span class="span1">
                          {{ item.number }}
                          {{ item.priceCompany }}
                        </span>
                        <span>{{ item.productName }}</span>
                      </div>
                      <p class="p1">
                        <span class="span1">{{ item.number }}</span>
                        <span class="span1">{{ item.priceCompany }}</span>
                        <span class="span4" v-if="item.startTime == item.endTime">{{ item.startTime }}</span>
                        <span class="span4" v-else>{{ item.startTime + "-" + item.endTime }}</span>
                      </p>
                      <p class="p3">
                        <!-- [标准价] 早餐2份 果盘一份 3晚 3间 入住当天23:00前免费取消 -->
                      </p>
                    </div>
                    <div class="right">
                      <div @click="handlerSelectBtnsClick(item1)" class="bntlist" v-for="(item1, index1) in btnsList"
                        :key="index1">
                        {{ item1 }}
                      </div>
                      <div class="date" v-if="isShow">
                        <div @click="handlerSelectBtnsClick('同样房间数量')" :class="current === '同样房间数量' ? 'active' : ''"
                          class="btns3" style="margin-bottom: 0.1rem">
                          同样房间数量
                        </div>
                        <div @click="handlerSelectBtnsClick('不同房间数量')" :class="current === '不同房间数量' ? 'active' : ''"
                          class="btns3">
                          不同房间数量
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="200" align="center" prop="address" label="单元（元）*数量 *汇率 ">
              <template slot-scope="scope">
                <div class="tableLine3" v-for="(item, index) in scope.row.orderListDetailResultList" :key="index">
                  <div class="p1">
                    <p class="p1">{{ item.currency }}<el-input size="mini" v-model="item.price"
                        style="width: 0.7rem; margin-right: 0.05rem"></el-input><span v-if="item.priceCompany">/{{
                          item.priceCompany
                        }}</span><span v-if="item.useTime">/</span> {{ item.useTime }}</p>
                  </div>
                  <p class="p2">{{ item.number }}{{ item.priceCompany }} {{ days(item.startTime,
                    item.endTime, scope.row.state) + 1 }}{{ item.useTime }}</p>
                  <p class="p3">
                    <span>
                      汇率：<span class="span1">{{ item.rate }}</span>
                    </span><span class="span1" style="margin-left: 0.1rem;">{{ totalOnePrice(item) }}¥</span>
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="name" label="商品总价（元）" width="180">
              <template slot-scope="scope">
                <div class="tableLine4">
                  <p class="p1">{{ totalPrice(scope.row.orderListDetailResultList) }}￥</p>
                  <p>-30.00</p>
                  <p>满300减20</p>
                  <p>满600减10</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column :min-width="550" fixed="right" align="center" prop="address" label="订单状态及操作">
              <template slot-scope="scope">
                <div class="tableLine4" v-if="scope.row.truncationResult">
                  <bookState :isLock="true" :orderChildrenId="scope.row.orderChildrenId" :allDatas="scope.row"
                    :datas="scope.row.truncationResult"></bookState>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </main>
        <!-- <el-input style="margin-bottom: 0.2rem" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请在此处详细描述变更原因。注意，客户如果不接受变更，可以取消订单。">
        </el-input> -->
      </div>
      <footer class="footer">
        <div style="display: flex; justify-content: center">
          <el-button @click="handlerTuiClick" style="width: 2.5rem" type="primary">调整完成 通知客户</el-button>
        </div>
      </footer>
    </el-dialog>
    <rollPopup ref="rollPopup"></rollPopup>
    <conditionPopup ref="conditionPopup"></conditionPopup>
  </div>
</template>

<script>
import rollPopup from "./rollPopup.vue";
import conditionPopup from "./conditionPopup.vue";
import { days } from '@/assets/utils/unit';
import OrderApi from "@/components/Api/order";
export default {
  components: {
    rollPopup,
    conditionPopup,
    bookState: () => import('./bookState.vue')
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      days,
      dialogVisible: false,
      // btnsList: ["调整名单", "增加日期", "调整条件"],
      btnsList: ["调整名单"],
      current: "同样房间数量",
      isShow: false,
      value: "",
      cities: [
        {
          value: "834777",
          label: "单人间",
        },
        {
          value: "999939",
          label: "双人间",
        },
      ],
      currencyList: [
        {
          value: "1",
          label: "$",
        },
        {
          value: "2",
          label: "¥",
        },
      ],
    };
  },
  computed: {
    //计算总价钱
    totalPrice() {
      return function (arr) {
        let price = 0
        arr.forEach(n => {
          price += n.price * n.number * n.rate
        });
        return price.toFixed(2)
      }
    },
    //计算单个总价钱
    totalOnePrice() {
      return function (n) {
        let price = 0
        price += n.price * n.number * n.rate
        return price.toFixed(2)
      }
    }
  },
  watch: {},
  methods: {
    //调整名单日期
    handlerSelectBtnsClick(item) {
      let that = this;
      const map = {
        // 调整名单: () => (this.$refs.rollPopup.dialogVisible = true),
        调整名单: () => alert('暂未开发'),
        增加日期: () => (this.isShow = true),
        调整条件: () => (this.$refs.conditionPopup.dialogVisible = true),
        同样房间数量: function () {
          that.current = item;
        },
        不同房间数量: function () {
          that.current = item;
        },
      };
      if (map[item]) {
        map[item]();
      }
    },
    handlerTuiClick() {
      let obj = this.tableData[0]
      this.$confirm(`调整完成了?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        new OrderApi("order")
          .adjustingOrdersAndAmounts(obj.orderListDetailResultList, obj.orderChildrenId)
          .then((res) => {
            if (res.status == 200) {
              this.$message({
                type: "success",
                message: "调整完成",
              });
              this.dialogVisible = false;
            } else {
              this.$message.error({ message: res.statusText });
            }
          });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "取消操作",
        });
      });
    },
  },
  created() { },
  mounted() {

  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header {
  padding: 0 !important;
}

/deep/ .el-dialog {
  border-radius: 0 !important;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
  padding-bottom: 0.5rem !important;
}

/deep/ .el-dialog__headerbtn {
  display: none;
}

/deep/ .el-checkbox__inner {
  border-radius: 50% !important;
}

.active {
  background-color: #006FFF !important;
  color: #fff !important;
}

.header {
  height: 0.4rem;
  padding: 0 0.2rem 0 0.4rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 0.28rem;
}

.main {
  margin-bottom: 0.2rem;

  .tableLine1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.05rem;

    .p1 {
      color: #006FFF;
      font-size: 0.1rem;
      font-family: SourceHanSansSC-regular;
    }

    .btns1 {
      width: 40px;
      height: 20px;
      line-height: 20px;
      border-radius: 8px;
      background-color: #DE562C;
      color: rgba(255, 255, 255, 1);
      font-size: 0.1rem;
      text-align: center;
      font-family: PingFang SC;
      margin-right: 0.12rem;
    }
  }

  .p2 {
    color: rgba(16, 16, 16, 1);
    font-size: 0.1rem;
    font-family: SourceHanSansSC-regular;
    margin-bottom: 0.05rem;
  }

  .p3 {
    color: #006FFF;
    font-size: 0.1rem;
    font-weight: bold;
    font-family: SourceHanSansSC-bold;
    margin-bottom: 0.05rem;
  }
  .p5 {
    color: #d81b43;
    font-size: 0.12rem;
    font-family: SourceHanSansSC-bold;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不换行
  }
  .tableLine2 {
    text-align: left;
    border-top: 1px solid #dbdbdb;
    display: flex;
    // justify-content: start;
    justify-content: center;
    flex-direction: column;

    &:nth-child(1) {
      border: none;
    }

    .left {
      display: flex;

      .p1 {
        margin-bottom: 0.05rem;
        display: flex;

        .span1 {
          color: rgba(216, 27, 67, 1);
          font-size: 0.1rem;
          font-family: SourceHanSansSC-bold;
          font-weight: bold;
          margin-right: 0.1rem;
          white-space: nowrap;
        }

        .span3 {
          color: #006FFF;
          font-size: 0.1rem;
          text-align: center;
          font-family: SourceHanSansSC-regular;
        }

        .add {
          cursor: pointer;
          width: 1rem;
          height: 0.22rem;
          line-height: 0.22rem;
          border-radius: 0.14rem 0.05rem 0rem 0.14rem;
          background-color: rgba(176, 173, 173, 0.26);
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-right: 0.06rem;
        }
      }
    }

    .right {
      position: relative;

      .bntlist {
        width: 0.8rem;
        height: 0.2rem;
        line-height: 0.2rem;
        color: #006FFF;
        font-size: 0.1rem;
        text-align: center;
        font-family: SourceHanSansSC-regular;
        background-color: #F1FAF9;
        border-radius: 0.05rem;
        margin-bottom: 0.06rem;
        cursor: pointer;
      }

      .date {
        padding: 0.1rem;
        position: absolute;
        left: -1.1rem;
        top: 0.2rem;
        background-color: #fff;

        .btns3 {
          width: 1;
          height: 0.25rem;
          line-height: 0.25rem;
          font-size: 12px;
          text-align: center;
          font-family: SourceHanSansSC-regular;
          background-color: #F1FAF9;
          color: #006FFF;
          cursor: pointer;
          padding: 0 0.03rem;
        }
      }
    }

  }

  .tableLine3 {
    text-align: left;

    .p1 {
      color: #006FFF;
      font-size: 0.1rem;
      font-weight: bold;
      font-family: SourceHanSansSC-bold;
      margin-bottom: 0.05rem;
    }

    .p3 {
      .span1 {
        color: rgba(216, 27, 67, 1);
        font-size: 0.1rem;
        font-family: SourceHanSansSC-bold;
        font-weight: bold;
      }
    }

    .line {
      border-bottom: 1px solid #dbdbdb;
      margin: 0.06rem 0;
    }
  }

  .tableLine4 {
    .p1 {
      color: rgba(216, 27, 67, 1);
      font-size: 0.1rem;
      font-family: SourceHanSansSC-bold;
      font-weight: bold;
    }

    p {
      margin-bottom: 0.05rem;
    }
  }
}

.footer {
  padding: 0 0.85rem;

  .footerLine1 {
    display: flex;
    align-items: center;
    margin-bottom: 0.05rem;

    .p1 {
      color: rgba(68, 66, 66, 1);
      font-size: 0.16rem;
      font-family: SourceHanSansSC-regular;
    }
  }
}
</style>
